import { useEffect, useState } from 'react';
import { GlobalStyles, useResolution } from '@lingoda/ui';
import { DixaMessenger } from '@lingoda/help-center';
import { hideDixaMixin } from './hideDixaMixin';

interface DixaVisibilityProps {
    hidden?: boolean;
}

export const DixaVisibility = ({ hidden = false }: DixaVisibilityProps) => {
    const isPhablet = useResolution('phablet');
    const shouldHideDixaDependingOnExternalFactors = isPhablet || hidden;
    const [showDixaManually, setShowDixaManually] = useState<boolean>(false);

    // set up listener for widget open/close
    useEffect(() => {
        if (!DixaMessenger.getIsDixaInitialized()) {
            return;
        }
        const handleChangeWidgetOpen = (isOpen: boolean) => {
            if (!shouldHideDixaDependingOnExternalFactors) {
                return;
            }

            if (isOpen) {
                // show Dixa on request despite fact, that we are on mobile or on a page where it should be hidden
                setShowDixaManually(true);
            } else {
                // hide Dixa when widget is closed
                setShowDixaManually(false);
            }
        };

        const removeListener = DixaMessenger.widgetOpenListener(handleChangeWidgetOpen);

        return () => {
            removeListener();
        };
    }, [shouldHideDixaDependingOnExternalFactors]);

    return !showDixaManually && shouldHideDixaDependingOnExternalFactors ? (
        <GlobalStyles styles={hideDixaMixin()} />
    ) : null;
};
